var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chart',{staticClass:"chart",attrs:{"option":_vm.option}})
}
var staticRenderFns = []

export { render, staticRenderFns }